export default __webpack_public_path__ + "img/ab53ef50e9b7a4b868af197aed360c19.svg";